__turbopack_context__.v({
  "slide": "styles-module__hKzCHW__slide",
});
